export enum LenderRankingSummaryType {
  TOP = 'TOP',
  REST = 'REST',
  TOTAL = 'TOTAL',
}
